import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Collapse,
  Box,
  ListItemText,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import InvestigationForm from "../../InvestigationForm";
import { useContext, useState } from "react";
import { contextType, RadiologyContext } from "../Radiology";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { getRadiologyList } from "../../../../services";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { InvestigationFormType, RadiologyTableType } from "../../types";
import RemoveIcon from "@mui/icons-material/Remove";
import CheckIcon from "@mui/icons-material/Check";
// import LogComonent from "../../../layouts/LogComonent";
import Close from "@mui/icons-material/Close";
import { EmrContext } from "../../../..";
import useDeleteActivity from "../../../hook/useDeleteActivity";
import HistoryComponent from "../../../layouts/HistoryComponent";

const RadiologyTable = () => {
  const [show, setShow] = useState(false);
  const { encounterId } = useParams();
  const [selected, setSelected] = useState(-1);
  const {
    tableData,
    setEdit,
    edit,
    setTableData,
    refetchRadiology,
    setRefechRadiology,
  } = useContext(RadiologyContext) as contextType;
  const { patientData } = useContext(EmrContext);
  // const { mutate: fetchRadiology } = useMutation(getRadiologyList, {
  //   onSuccess: (result) => {
  //     setTableData(result.response.items || []);
  //     setRefechRadiology(false);
  //   },
  //   onError: () => {
  //     setRefechRadiology(false);
  //   },
  // });

  const { refetch } = useQuery(
    ["fetchRadiologyList", refetchRadiology],
    async () => getRadiologyList({ encounterId: Number(encounterId) }),
    {
      onSuccess: (result) => {
        setTableData(result.response.items || []);
        setRefechRadiology(false);
      },
      onError: () => {
        setRefechRadiology(false);
      },
      enabled: Boolean(encounterId),
      refetchOnWindowFocus: false,
    },
  );

  //  const refetch = ()=>{fetchRadiology({encounterId: parseInt(encounterId as string)});}

  const { mutate: radiologyDelete, isLoading: deleteLoading } =
    useDeleteActivity(refetch);

  const handleEdit = (data: RadiologyTableType) => {
    const update: InvestigationFormType = {
      amount: patientData.pmaster.paymentMode
        ? data.isExcluded
          ? data.radiologyDetailsPshare
          : data.radiologyDetailsInsAmount || data.radiologyDetailsAmt
        : data.radiologyDetailsPshare,
      approvalRequired: data.radiologyDetailsApproval,
      cpt: {
        cptCode: data.cptCode,
        cptId: data.cptId,
        cptRate: Number(data.cptRate || 0),
        cptName: data.cptName,
        cptDes: data.cptDes,
        cptGroupId: 1,
        insCoverage: data.insCoverage,
      },
      encounterId: encounterId as string,
      IsPerfomed: data.radiologyDetailsIsPerformed,
      outHouse: data.radiologyDetailsOutHouse,
      radiologyId: data.radiologyDetailsId,
      patientshare:
        patientData.pmaster.paymentMode == 1
          ? data.isExcluded
            ? data.radiologyDetailsAmt
            : data.radiologyDetailsPshare
          : data.radiologyDetailsPshare,
      Quantity: data.radiologyDetailsQty.toString(),
      Rate: data.unitRate,
      Reason: data.radiologyDetailsReason,
      Remark: data.radiologyDetailsRemarks,
      isExcluded: data.isExcluded || false,
      createdDate: data.createdByDate,
      insuranceCoverage: Boolean(data?.insCoverage),
      discount: data.discountAmount || data.discountPercentage || 0,
      discountType: data.discountType || "",
    };
    setEdit(update);
    setShow(false);
  };

  const handleDelete = (item: RadiologyTableType, index: number) => {
    radiologyDelete({
      activityId: item.radiologyDetailsId,
      cptGrpId: 1,
      encounterId: parseInt(encounterId as string),
      paymentMode: patientData?.pmaster?.paymentMode,
    });
    setSelected(index);
  };

  const handleClose = () => {
    setEdit(null);
  };

  // useEffect(() => {
  //   if (refetchRadiology) {
  //     fetchRadiology({ encounterId: parseInt(encounterId as string) });
  //   }
  // }, [refetchRadiology]);

  return (
    <div>
      <Paper>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow
                sx={(theme) => ({
                  backgroundColor: theme.palette.primary.main,
                })}
              >
                {heading.map((heading, index) => (
                  <TableCell
                    sx={(theme) => ({ color: theme.palette.background.paper })}
                    align="left"
                    key={`heading${index}`}
                  >
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                  {!show && (
                    <div className="w-full flex justify-end items-center p-2 gap-3">
                      <Button
                        color="success"
                        endIcon={<AddCircleIcon />}
                        onClick={() => {
                          setShow(true);
                          setEdit(null);
                        }}
                      >
                        add
                      </Button>
                      <div>
                        {/* <LogComonent /> */}
                        <HistoryComponent
                          logProps={{
                            field: "radiologydetails",
                            title: "Radiology",
                          }}
                          title="Radiology"
                          tableprops={tableProps}
                        />
                      </div>
                    </div>
                  )}
                  <Collapse in={show} timeout="auto" unmountOnExit>
                    <Box>
                      <InvestigationForm
                        formType="radiology"
                        close={() => {
                          setShow(false);
                        }}
                      />
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
              {tableData?.map((item: RadiologyTableType, index: number) => (
                <>
                  <TableRow key={index}>
                    <TableCell>
                      <ListItemText
                        primary={
                          <span>
                            <Typography>
                              {`${item.cptDes}`} ({item.cptCode})
                            </Typography>
                          </span>
                        }
                        secondary={
                          item.radiologyDetailsApproval && (
                            <Typography color="primary" fontSize={".7rem"}>
                              Approval required
                            </Typography>
                          )
                        }
                      ></ListItemText>
                    </TableCell>

                    <TableCell>{Number(item.unitRate).toFixed(2)}</TableCell>
                    <TableCell>{item.radiologyDetailsQty}</TableCell>
                    <TableCell>
                      {item.discountAmount && `${item.discountAmount}`}
                      {item.discountPercentage &&
                        `${item.discountPercentage} %`}
                    </TableCell>
                    <TableCell>
                      {Number(
                        patientData.pmaster.paymentMode
                          ? item.isExcluded
                            ? item.radiologyDetailsAmt
                            : item.radiologyDetailsInsAmount ||
                              item.radiologyDetailsAmt
                          : item.radiologyDetailsAmt,
                      ).toFixed(2)}
                    </TableCell>
                    <TableCell>
                      {Number(item.radiologyDetailsPshare).toFixed(2)}
                    </TableCell>
                    <TableCell>
                      {item.radiologyDetailsOutHouse ? (
                        <CheckIcon color="success" />
                      ) : (
                        <RemoveIcon color="error" />
                      )}
                    </TableCell>
                    <TableCell>
                      {item.radiologyDetailsApproval ? (
                        <CheckIcon color="success" />
                      ) : (
                        <RemoveIcon color="error" />
                      )}
                    </TableCell>
                    <TableCell>
                      {item.radiologyDetailsIsPerformed ? (
                        <CheckIcon color="success" />
                      ) : (
                        <RemoveIcon color="error" />
                      )}
                    </TableCell>
                    <TableCell>{item.radiologyDetailsRemarks}</TableCell>
                    <TableCell>{item.radiologyDetailsReason}</TableCell>
                    <TableCell>
                      <div className="flex gap-2">
                        {edit?.radiologyId == item?.radiologyDetailsId ? (
                          <IconButton onClick={handleClose} color="error">
                            <Close />
                          </IconButton>
                        ) : (
                          <IconButton
                            color="primary"
                            onClick={() => {
                              handleEdit(item);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                        {deleteLoading && selected == index ? (
                          <CircularProgress
                            size={20}
                            sx={{ color: "red", marginTop: "5px" }}
                          />
                        ) : (
                          <IconButton
                            color="error"
                            onClick={() => {
                              handleDelete(item, index);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                      <Collapse
                        in={
                          Boolean(edit) &&
                          edit?.radiologyId == item?.radiologyDetailsId
                        }
                        timeout="auto"
                        unmountOnExit
                      >
                        <InvestigationForm
                          formType="radiology"
                          close={() => {
                            setEdit(null);
                          }}
                        />
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

const heading = [
  "Item",
  "Unit Rate",
  "Quantity",
  "Discount",
  "Amount",
  "PatientShare",
  "Out house",
  "Approval required",
  "Already performed",
  "Remark",
  "Reason",
  "Options",
];

const tableProps = [
  { heading: "Item", key: "cptDes" },
  { heading: "Unit Rate", key: "unitRate" },
  { heading: "Quantity", key: "radiologyDetailsQty" },
  { heading: "Amount", key: "radiologyDetailsAmt" },
  { heading: "PatientShare", key: "radiologyDetailsPshare" },
  { heading: "Remark", key: "radiologyDetailsRemarks" },
  { heading: "Reason", key: "radiologyDetailsReason" },
  { heading: "Created Date", key: "createdByDate", date: "DD-MM-YYYY" },
];
export default RadiologyTable;
